export const types = {
    login: '[auth] login',
    logout: '[auth] logout',
    singup: '[auth] singup',
    editPet: '[auth] editPet',
    setCoords: '[auth] setCoords',
    setAddress: '[auth] setAddress',
    editAlert: '[auth] editAlert',
    editPost: '[auth] editPost',
}